import { isArabicUi } from "@/shared/config/arabicUi";

/**
 * Подписи нового меню кабинета и экранов «сайт без приложения».
 *
 * Словарь лежит здесь, а не в общих locales/*.json: это предпросмотр для
 * админов, и названия ещё может поправить владелец. Когда меню откроют всем,
 * строки переедут в локали обычным порядком. Русский и английский есть
 * целиком; на немецком, испанском и китайском переведено само меню и панель
 * вокруг него (NAV_MENU_KEYS), прочее пока английское. Арабский — целиком, но
 * только при включённом арабском интерфейсе (shared/config/arabicUi); пока он
 * выключен, /ar — английский, как и весь сайт там (решение D15).
 */
const RU = {
    // Разделы — как вкладки приложения (V4_Names). «Ответы и курсы» разделены
    // на «Умный поиск» и «Курсы» (владелец, 29.09); «СУП» людям не пишем.
    training: "Тренировки",
    calendar: "Календарь",
    progress: "Прогресс и лига",
    diet: "Диета и диагностика",
    smartSearch: "Умный поиск",
    courses: "Курсы",
    community: "Общение и встречи",
    inApp: "в приложении",
    // Стрелка у раздела-ссылки: раскрыть его пункты, не открывая страницу.
    sectionItems: "Пункты раздела «{{section}}»",
    // Прогресс и лига
    points: "Баллы",
    analytics: "Аналитика",
    nutrition: "Питание",
    leagueUsers: "Лига участников",
    achievements: "Достижения",
    leagueClubs: "Лига клубов",
    progressSub: "Баллы · Аналитика · Лига",
    // Диета и диагностика
    dietItem: "Диета",
    diagnostics: "Диагностика",
    consultations: "Мои консультации",
    consultationsEmail: "Email диагностики (диета, ЗОЖ, консультации)",
    trees: "Деревья",
    areaOfLife: "Сфера жизни",
    dietSub: "Диета · Диагностика",
    // Умный поиск
    specialist: "Мои вопросы специалисту",
    knowledge: "База знаний",
    tokens: "Токены",
    // Курсы
    lectures: "Мои лекции",
    streams: "Эфиры",
    // Общение и встречи
    meetings: "Встречи",
    chats: "Чаты",
    people: "Люди",
    communitySub: "Встречи · Чаты · Люди",
    // Меню профиля
    profileMenu: "Меню профиля",
    profile: "Профиль",
    purchases: "Подписка и покупки",
    products: "Все продукты", // v5-products
    newTag: "новое", // v5-products
    gifts: "Мои подарки",
    referral: "Реферальная программа",
    reviews: "Мои отзывы",
    settings: "Настройки",
    hrZones: "Зоны пульса и длина шага",
    support: "Поддержка",
    notifications: "Уведомления",
    language: "Язык",
    logout: "Выйти",
    viewAsUser: "Смотреть как пользователь",
    // Админ выключил вид приложения на телефоне («Прежний вид сайта») — включить обратно.
    appLookOn: "Включить вид приложения",
    adminPreview: "Новое меню видят только админы",
    menu: "Меню",
    sections: "Разделы",
    close: "Закрыть",
    toHome: "На главную",
    // Экран «Тренировки / Календарь» без приложения (V4_T4)
    appCardTitle: "Тренировки и план — в приложении MY REVIVE",
    appPreviewTraining: "Тренировки",
    appPreviewPlan: "План — по дням",
    appPreviewLabel:
        "Так это выглядит в приложении: список тренировок, в нём «Конструктор плана», и план по дням",
    planTitle: "План тренировок — в приложении",
    planSub: "с годовой подпиской или со всеми 3 частями курса «Восстановление жизненных сил»",
    planChip: "тренировки за неделю по плану",
    featSensors: "Датчики и пульс",
    featFastTimer: "Таймер поста",
    featWatches: "Часы Garmin и Wear OS",
    featTests: "Тестовые тренировки",
    install: "Установить приложение",
    installShort: "Установить",
    openInApp: "Открыть в приложении MY REVIVE",
    uploadNote: "Файлы с часов (.fit, .gpx, .tcx) — загружаются в приложении",
    oldVersion: "старая версия",
    oldCalendar: "календарь",
    oldTesting: "тестовая тренировка",
    oldPlan: "план",
    oldUpload: "загрузка файла",
    // «Общение и встречи» на сайте (V4_S2)
    communityAppCard: "Встречи и чаты — в приложении: уведомления сразу",
    more: "Ещё в «Общении и встречах»",
    nextTitle: "Ближайшая встреча",
    calendarLink: "Календарь встреч",
    nextEmpty: "Ближайших встреч нет",
    createMeeting: "Создать встречу",
    meetingsMap: "Карта встреч",
    aheadTitle: "Впереди рядом",
    twoWeeks: "2 недели",
    month: "Месяц",
    aheadEmpty: "Рядом в эти дни ничего не запланировано",
    allEvents: "Все мероприятия",
    going: "идут {{going}} · приглашены {{invited}}",
    // Формы через «|» — для pluralCount: одна | несколько | много.
    requests: "{{n}} просьба|{{n}} просьбы|{{n}} просьб",
    roleOrganizer: "вы организатор",
    roleMaybe: "возможно",
    roleGoing: "иду",
    online: "онлайн",
    untitled: "Без названия",
    loading: "Загружаю…",
    loadFailed: "Не загрузилось",
    retry: "Повторить",
    chatsAll: "Все",
    chatsPersonal: "Личные",
    chatsGroups: "Группы",
    chatsMeetings: "Встречи",
    chatsNone: "Чатов пока нет",
    chatsArchive: "Архив",
    chatsOpenAll: "Все чаты",
    kindDirect: "личный",
    kindGroup: "группа",
    kindMeeting: "встреча",
    kindMeetingPast: "встреча прошла",
    you: "Вы",
    chatEmpty: "Пока пусто",
    peopleSearch: "Имя или город",
    friends: "Друзья",
    friendsOnline: "{{count}} · {{online}} в сети",
    friendsAll: "Все",
    friendsNone: "Друзей пока нет",
    requestToYou: "Заявка вам",
    accept: "Принять",
    decline: "Отклонить",
    noClub: "без клуба",
    clubPrefix: "Клуб",
    // V4_S4 и владелец 29.09: сначала выгода самого человека (10 % с покупок друга на
    // баланс — строкой под названием), скидка другу — в названии; баллы — мелкими чипами.
    inviteFriend: "Пригласить друга · другу −{{pct}} %",
    myClub: "Мой клуб",
    clubMember: "Участник",
    clubManager: "Организатор",
    clubPending: "Заявка отправлена",
    clubNone: "Клуб не выбран",
    clubChoose: "Выбрать клуб рядом",
    goodDeeds: "Мои добрые дела",
    // «в зачёт клуба в лиге» с макета не пишем: эта страница (statuses.json)
    // в лигу клубов не идёт — туда идёт недельный журнал дел клуба.
    goodDeedsToday: "Сегодня отмечено: {{n}}",
    newGroup: "Новая группа",
    findPeople: "Найти людей",
    myCity: "Мой город",
    oldCommunity: "Старая версия страницы (с картой)",
    moderation: "Модерация",
} as const;

export type NavStringKey = keyof typeof RU;

const EN: Record<NavStringKey, string> = {
    training: "Workouts",
    calendar: "Calendar",
    progress: "Progress & league",
    diet: "Diet & diagnostics",
    smartSearch: "Smart search",
    courses: "Courses",
    community: "Community & meetings",
    inApp: "in the app",
    sectionItems: "“{{section}}” items",
    points: "Points",
    analytics: "Analytics",
    nutrition: "Nutrition",
    leagueUsers: "Members league",
    achievements: "Achievements",
    leagueClubs: "Clubs league",
    progressSub: "Points · Analytics · League",
    dietItem: "Diet",
    diagnostics: "Diagnostics",
    consultations: "My consultations",
    consultationsEmail: "Diagnostics email (diet, healthy lifestyle, consultations)",
    trees: "Trees",
    areaOfLife: "Area of life",
    dietSub: "Diet · Diagnostics",
    specialist: "My questions to a specialist",
    knowledge: "Knowledge base",
    tokens: "Tokens",
    lectures: "My lectures",
    streams: "Live streams",
    meetings: "Meetings",
    chats: "Chats",
    people: "People",
    communitySub: "Meetings · Chats · People",
    profileMenu: "Profile menu",
    profile: "Profile",
    purchases: "Subscription & purchases",
    products: "All products", // v5-products
    newTag: "new", // v5-products
    gifts: "My gifts",
    referral: "Referral program",
    reviews: "My reviews",
    settings: "Settings",
    hrZones: "HR zones & step length",
    support: "Support",
    notifications: "Notifications",
    language: "Language",
    logout: "Log out",
    viewAsUser: "View as a regular user",
    appLookOn: "Turn the app look on",
    adminPreview: "Only admins see the new menu",
    menu: "Menu",
    sections: "Sections",
    close: "Close",
    toHome: "To the home page",
    appCardTitle: "Workouts and plan — in the MY REVIVE app",
    appPreviewTraining: "Workouts",
    appPreviewPlan: "Plan — by day",
    appPreviewLabel:
        "How it looks in the app: the workout list with the “Plan builder”, and the plan by day",
    planTitle: "Workout plan — in the app",
    planSub: "with the annual subscription or with all 3 parts of the “Restoring vital energy” course",
    planChip: "workout points for a week on plan",
    featSensors: "Sensors and heart rate",
    featFastTimer: "Fasting timer",
    featWatches: "Garmin and Wear OS watches",
    featTests: "Test workouts",
    install: "Install the app",
    installShort: "Install",
    openInApp: "Open in the MY REVIVE app",
    uploadNote: "Watch files (.fit, .gpx, .tcx) — upload them in the app",
    oldVersion: "old version",
    oldCalendar: "calendar",
    oldTesting: "test workout",
    oldPlan: "plan",
    oldUpload: "file upload",
    communityAppCard: "Meetings and chats — in the app: instant notifications",
    more: "More in “Community & meetings”",
    nextTitle: "Next meeting",
    calendarLink: "Meetings calendar",
    nextEmpty: "No upcoming meetings",
    createMeeting: "Create a meeting",
    meetingsMap: "Meetings map",
    aheadTitle: "Coming up nearby",
    twoWeeks: "2 weeks",
    month: "Month",
    aheadEmpty: "Nothing planned nearby for these days",
    allEvents: "All events",
    going: "{{going}} going · {{invited}} invited",
    requests: "{{n}} request|{{n}} requests",
    roleOrganizer: "you organise",
    roleMaybe: "maybe",
    roleGoing: "going",
    online: "online",
    untitled: "Untitled",
    loading: "Loading…",
    loadFailed: "Could not load",
    retry: "Retry",
    chatsAll: "All",
    chatsPersonal: "Personal",
    chatsGroups: "Groups",
    chatsMeetings: "Meetings",
    chatsNone: "No chats yet",
    chatsArchive: "Archive",
    chatsOpenAll: "All chats",
    kindDirect: "personal",
    kindGroup: "group",
    kindMeeting: "meeting",
    kindMeetingPast: "meeting over",
    you: "You",
    chatEmpty: "Nothing yet",
    peopleSearch: "Name or city",
    friends: "Friends",
    friendsOnline: "{{count}} · {{online}} online",
    friendsAll: "All",
    friendsNone: "No friends yet",
    requestToYou: "Request to you",
    accept: "Accept",
    decline: "Decline",
    noClub: "no club",
    clubPrefix: "Club",
    inviteFriend: "Invite a friend · −{{pct}}% for them",
    myClub: "My club",
    clubMember: "Member",
    clubManager: "Organiser",
    clubPending: "Request sent",
    clubNone: "No club yet",
    clubChoose: "Choose a club nearby",
    goodDeeds: "My good deeds",
    goodDeedsToday: "Marked today: {{n}}",
    newGroup: "New group",
    findPeople: "Find people",
    myCity: "My city",
    oldCommunity: "Old version of the page (with the map)",
    moderation: "Moderation",
};

/**
 * Подписи самого меню — разделы, их пункты, подписи под свёрнутыми разделами,
 * то, что читает экранный диктор у дерева разделов, — и всё, что на той же
 * панели вокруг него (боковая панель, шапка и выезжающее меню телефона, меню
 * профиля): одна панель — один язык. Они на каждом языке сайта (владелец,
 * 03.10: «естественно на каждом языке перевести нужно на этот язык»); где у
 * сайта или приложения перевод уже был (locales/*.json, строки оболочки
 * appShell), он тот же. Что не здесь, на этих языках пока английское.
 */
export const NAV_MENU_KEYS: readonly NavStringKey[] = [
    "training",
    "calendar",
    "progress",
    "diet",
    "smartSearch",
    "courses",
    "community",
    "inApp",
    "sectionItems",
    "sections",
    "points",
    "analytics",
    "nutrition",
    "leagueUsers",
    "achievements",
    "leagueClubs",
    "progressSub",
    "dietItem",
    "diagnostics",
    "consultations",
    "consultationsEmail",
    "trees",
    "areaOfLife",
    "dietSub",
    "specialist",
    "knowledge",
    "tokens",
    "lectures",
    "streams",
    "meetings",
    "chats",
    "people",
    "communitySub",
    // Панель вокруг дерева: SidebarV5, MobileHeaderV5, ProfileMenu.
    "menu",
    "toHome",
    "close",
    "adminPreview",
    "profileMenu",
    "notifications",
    "profile",
    "purchases",
    "products",
    "newTag",
    "gifts",
    "referral",
    "reviews",
    "settings",
    "hrZones",
    "support",
    "language",
    "logout",
    "viewAsUser",
    "appLookOn",
];

type NavDict = Partial<Record<NavStringKey, string>>;

const DE: NavDict = {
    training: "Trainings",
    calendar: "Kalender",
    progress: "Fortschritt & Liga",
    diet: "Ernährung & Diagnostik",
    smartSearch: "Intelligente Suche",
    courses: "Kurse",
    community: "Community & Treffen",
    inApp: "in der App",
    sectionItems: "Einträge von „{{section}}“",
    sections: "Bereiche",
    points: "Punkte",
    analytics: "Analyse",
    nutrition: "Ernährung",
    leagueUsers: "Teilnehmerliga",
    achievements: "Erfolge",
    leagueClubs: "Clubliga",
    progressSub: "Punkte · Analyse · Liga",
    dietItem: "Ernährung",
    diagnostics: "Diagnostik",
    consultations: "Meine Beratungen",
    consultationsEmail: "Diagnostik-E-Mail (Ernährung, Lebensstil, Beratungen)",
    trees: "Bäume",
    areaOfLife: "Lebensbereiche",
    dietSub: "Ernährung · Diagnostik",
    specialist: "Meine Fragen an einen Fachmann",
    knowledge: "Wissensdatenbank",
    tokens: "Token",
    lectures: "Meine Vorträge",
    streams: "Livestreams",
    meetings: "Treffen",
    chats: "Chats",
    people: "Menschen",
    communitySub: "Treffen · Chats · Menschen",
    menu: "Menü",
    toHome: "Zur Startseite",
    close: "Schließen",
    adminPreview: "Das neue Menü sehen nur Admins",
    profileMenu: "Profilmenü",
    notifications: "Benachrichtigungen",
    profile: "Profil",
    purchases: "Abo und Käufe",
    products: "Alle Produkte",
    newTag: "neu",
    gifts: "Meine Geschenke",
    referral: "Partnerprogramm",
    reviews: "Meine Bewertungen",
    settings: "Einstellungen",
    hrZones: "Pulszonen und Schrittlänge",
    support: "Support",
    language: "Sprache",
    logout: "Abmelden",
    viewAsUser: "Als normaler Nutzer ansehen",
    appLookOn: "App-Ansicht einschalten",
};

const ES: NavDict = {
    training: "Entrenamientos",
    calendar: "Calendario",
    progress: "Progreso y liga",
    diet: "Dieta y diagnóstico",
    smartSearch: "Búsqueda inteligente",
    courses: "Cursos",
    community: "Comunidad y encuentros",
    inApp: "en la app",
    sectionItems: "Elementos de «{{section}}»",
    sections: "Secciones",
    points: "Puntos",
    analytics: "Análisis",
    nutrition: "Alimentación",
    leagueUsers: "Liga de participantes",
    achievements: "Logros",
    leagueClubs: "Liga de clubes",
    progressSub: "Puntos · Análisis · Liga",
    dietItem: "Dieta",
    diagnostics: "Diagnóstico",
    consultations: "Mis consultas",
    consultationsEmail: "Correo del diagnóstico (dieta, estilo de vida, consultas)",
    trees: "Árboles",
    areaOfLife: "Esferas de la vida",
    dietSub: "Dieta · Diagnóstico",
    specialist: "Mis preguntas a un especialista",
    knowledge: "Base de conocimiento",
    tokens: "Tokens",
    lectures: "Mis conferencias",
    streams: "Directos",
    meetings: "Encuentros",
    chats: "Chats",
    people: "Personas",
    communitySub: "Encuentros · Chats · Personas",
    menu: "Menú",
    toHome: "Ir al inicio",
    close: "Cerrar",
    adminPreview: "Solo los administradores ven el nuevo menú",
    profileMenu: "Menú del perfil",
    notifications: "Notificaciones",
    profile: "Perfil",
    purchases: "Suscripción y compras",
    products: "Todos los productos",
    newTag: "nuevo",
    gifts: "Mis regalos",
    referral: "Programa de referidos",
    reviews: "Mis reseñas",
    settings: "Ajustes",
    hrZones: "Zonas de pulso y longitud del paso",
    support: "Soporte",
    language: "Idioma",
    logout: "Cerrar sesión",
    viewAsUser: "Ver como usuario normal",
    appLookOn: "Activar la vista de la app",
};

/** Китайский сайта — `cn`. */
const CN: NavDict = {
    training: "训练",
    calendar: "日历",
    progress: "进度与联赛",
    diet: "饮食与诊断",
    smartSearch: "智能搜索",
    courses: "课程",
    community: "交流与聚会",
    inApp: "在应用中",
    sectionItems: "“{{section}}”的子项",
    sections: "栏目",
    points: "积分",
    analytics: "分析",
    nutrition: "饮食",
    leagueUsers: "成员联赛",
    achievements: "成就",
    leagueClubs: "俱乐部联赛",
    progressSub: "积分 · 分析 · 联赛",
    dietItem: "饮食",
    diagnostics: "诊断",
    consultations: "我的咨询",
    consultationsEmail: "诊断邮箱（饮食、健康生活方式、咨询）",
    trees: "树木",
    areaOfLife: "生活领域",
    dietSub: "饮食 · 诊断",
    specialist: "我向专家的提问",
    knowledge: "知识库",
    tokens: "代币",
    lectures: "我的讲座",
    streams: "直播",
    meetings: "聚会",
    chats: "聊天",
    people: "伙伴",
    communitySub: "聚会 · 聊天 · 伙伴",
    menu: "菜单",
    toHome: "返回首页",
    close: "关闭",
    adminPreview: "新菜单仅管理员可见",
    profileMenu: "个人资料菜单",
    notifications: "通知",
    profile: "个人资料",
    purchases: "订阅与购买",
    products: "全部产品",
    newTag: "新",
    gifts: "我的礼物",
    referral: "推荐计划",
    reviews: "我的评价",
    settings: "设置",
    hrZones: "心率区间与步长",
    support: "支持",
    language: "语言",
    logout: "退出登录",
    viewAsUser: "以普通用户身份查看",
    appLookOn: "开启应用外观",
};

/**
 * Арабский — целиком, но только при включённом арабском интерфейсе
 * (shared/config/arabicUi: рубильник или предпросмотр админа). Пока он
 * выключен, /ar — английский, как весь сайт там (D15): арабское меню посреди
 * английской страницы, да ещё слева направо, — хуже. Слова — как в арабском
 * приложении iPhone и в locales/ar.json; формы числа — шесть, через «|»
 * (zero | one | two | few | many | other).
 */
const AR: NavDict = {
    training: "التمارين",
    calendar: "التقويم",
    progress: "التقدّم والدوري",
    diet: "النظام الغذائي والتشخيص",
    smartSearch: "البحث الذكي",
    courses: "الدورات",
    community: "التواصل واللقاءات",
    inApp: "في التطبيق",
    sectionItems: "عناصر «{{section}}»",
    points: "النقاط",
    analytics: "التحليلات",
    nutrition: "التغذية",
    leagueUsers: "دوري الأعضاء",
    achievements: "الإنجازات",
    leagueClubs: "دوري الأندية",
    progressSub: "النقاط · التحليلات · الدوري",
    dietItem: "النظام الغذائي",
    diagnostics: "التشخيص",
    consultations: "استشاراتي",
    consultationsEmail: "بريد التشخيص (النظام الغذائي، نمط الحياة الصحي، الاستشارات)",
    trees: "الأشجار",
    areaOfLife: "مجال الحياة",
    dietSub: "النظام الغذائي · التشخيص",
    specialist: "أسئلتي إلى المختص",
    knowledge: "قاعدة المعرفة",
    tokens: "الرموز",
    lectures: "محاضراتي",
    streams: "البث المباشر",
    meetings: "اللقاءات",
    chats: "المحادثات",
    people: "الأشخاص",
    communitySub: "اللقاءات · المحادثات · الأشخاص",
    profileMenu: "قائمة الملف الشخصي",
    profile: "الملف الشخصي",
    purchases: "الاشتراك والمشتريات",
    products: "كل المنتجات",
    newTag: "جديد",
    gifts: "هداياي",
    referral: "برنامج الإحالة",
    reviews: "مراجعاتي",
    settings: "الإعدادات",
    hrZones: "مناطق النبض وطول الخطوة",
    support: "الدعم",
    notifications: "الإشعارات",
    language: "اللغة",
    logout: "تسجيل الخروج",
    viewAsUser: "العرض كمستخدم عادي",
    appLookOn: "تشغيل مظهر التطبيق",
    adminPreview: "القائمة الجديدة يراها المشرفون فقط",
    menu: "القائمة",
    sections: "الأقسام",
    close: "إغلاق",
    toHome: "إلى الصفحة الرئيسية",
    appCardTitle: "التمارين والخطة — في تطبيق MY REVIVE",
    appPreviewTraining: "التمارين",
    appPreviewPlan: "الخطة — بالأيام",
    appPreviewLabel: "كيف يبدو في التطبيق: قائمة التمارين مع «منشئ الخطة»، والخطة بالأيام",
    planTitle: "خطة التمارين — في التطبيق",
    planSub: "مع الاشتراك السنوي أو مع الأجزاء الثلاثة من دورة «استعادة الطاقة الحيوية»",
    planChip: "نقاط التمارين عن أسبوع وفق الخطة",
    featSensors: "المستشعرات والنبض",
    featFastTimer: "مؤقّت الصيام",
    featWatches: "ساعات Garmin وWear OS",
    featTests: "التمارين التجريبية",
    install: "ثبّت التطبيق",
    installShort: "تثبيت",
    openInApp: "افتح في تطبيق MY REVIVE",
    uploadNote: "ملفات الساعة (fit وgpx وtcx) — ارفعها في التطبيق",
    oldVersion: "النسخة القديمة",
    oldCalendar: "التقويم",
    oldTesting: "تمرين تجريبي",
    oldPlan: "الخطة",
    oldUpload: "رفع ملف",
    communityAppCard: "اللقاءات والمحادثات — في التطبيق: إشعارات فورية",
    more: "المزيد في «التواصل واللقاءات»",
    nextTitle: "اللقاء القادم",
    calendarLink: "تقويم اللقاءات",
    nextEmpty: "لا لقاءات قادمة",
    createMeeting: "إنشاء لقاء",
    meetingsMap: "خريطة اللقاءات",
    aheadTitle: "قريبًا بالقرب منك",
    twoWeeks: "أسبوعان",
    month: "شهر",
    aheadEmpty: "لا شيء مخطط له بالقرب منك في هذه الأيام",
    allEvents: "كل الفعاليات",
    going: "سيحضر {{going}} · مدعوون {{invited}}",
    requests: "لا طلبات|طلب واحد|طلبان|{{n}} طلبات|{{n}} طلبًا|{{n}} طلب",
    roleOrganizer: "أنت المنظِّم",
    roleMaybe: "ربما",
    roleGoing: "سأحضر",
    online: "عبر الإنترنت",
    untitled: "بلا عنوان",
    loading: "جارٍ التحميل…",
    loadFailed: "تعذّر التحميل",
    retry: "إعادة المحاولة",
    chatsAll: "الكل",
    chatsPersonal: "الخاصة",
    chatsGroups: "المجموعات",
    chatsMeetings: "اللقاءات",
    chatsNone: "لا محادثات بعد",
    chatsArchive: "الأرشيف",
    chatsOpenAll: "كل المحادثات",
    kindDirect: "خاصة",
    kindGroup: "مجموعة",
    kindMeeting: "لقاء",
    kindMeetingPast: "انتهى اللقاء",
    you: "أنت",
    chatEmpty: "لا شيء بعد",
    peopleSearch: "الاسم أو المدينة",
    friends: "الأصدقاء",
    friendsOnline: "{{count}} · متصلون الآن: {{online}}",
    friendsAll: "الكل",
    friendsNone: "لا أصدقاء بعد",
    requestToYou: "طلب إليك",
    accept: "قبول",
    decline: "رفض",
    noClub: "لا نادي",
    clubPrefix: "النادي",
    inviteFriend: "ادعُ صديقًا · −{{pct}}% له",
    myClub: "ناديّ",
    clubMember: "عضو",
    clubManager: "منظِّم",
    clubPending: "تم إرسال الطلب",
    clubNone: "لا نادي بعد",
    clubChoose: "اختر ناديًا قريبًا",
    goodDeeds: "أعمالي الطيبة",
    goodDeedsToday: "سُجّل اليوم: {{n}}",
    newGroup: "مجموعة جديدة",
    findPeople: "البحث عن أشخاص",
    myCity: "مدينتي",
    oldCommunity: "النسخة القديمة من الصفحة (مع الخريطة)",
    moderation: "الإشراف",
};

const OTHER_LANGS: Record<string, NavDict> = { de: DE, es: ES, cn: CN };

export type NavStrings = (key: NavStringKey, vars?: Record<string, string | number>) => string;

/**
 * Подписи на языке страницы: русский и английский — целиком; немецкий,
 * испанский и китайский — меню и панель вокруг него (NAV_MENU_KEYS), прочее
 * по-английски; арабский — целиком при включённом арабском интерфейсе, иначе,
 * как и незнакомое, — английский.
 */
export const navStrings = (lang: string): NavStrings => {
    const dict: NavDict =
        lang === "ru"
            ? RU
            : isArabicUi(lang)
              ? AR
              : Object.prototype.hasOwnProperty.call(OTHER_LANGS, lang)
                ? OTHER_LANGS[lang]
                : EN;
    return (key, vars) => {
        let s = dict[key] ?? EN[key] ?? RU[key] ?? key;
        if (vars) {
            for (const [k, v] of Object.entries(vars)) {
                s = s.split(`{{${k}}}`).join(String(v));
            }
        }
        return s;
    };
};

/** Арабские формы числа в порядке «|» словаря (CLDR). */
const AR_PLURAL_FORMS = ["zero", "one", "two", "few", "many", "other"];

/**
 * Число со словом в нужной форме: «1 просьба · 3 просьбы · 5 просьб»,
 * «1 request · 2 requests». Формы лежат в строке словаря через «|»: у
 * русского три (one | few | many), у английского две (one | other), у
 * арабского шесть (zero | one | two | few | many | other).
 */
export const pluralCount = (lang: string, key: NavStringKey, n: number): string => {
    const forms = navStrings(lang)(key, { n }).split("|");
    let idx: number;
    if (isArabicUi(lang) && forms.length === AR_PLURAL_FORMS.length) {
        let rule = "other";
        try {
            rule = new Intl.PluralRules("ar").select(n);
        } catch {
            rule = n === 0 ? "zero" : n === 1 ? "one" : n === 2 ? "two" : "other";
        }
        idx = Math.max(0, AR_PLURAL_FORMS.indexOf(rule));
    } else if (lang === "ru") {
        const d = Math.abs(n) % 10;
        const h = Math.abs(n) % 100;
        idx = !Number.isInteger(n)
            ? 1 // дробное: «1,5 просьбы»
            : d === 1 && h !== 11
              ? 0
              : d >= 2 && d <= 4 && (h < 12 || h > 14)
                ? 1
                : 2;
    } else {
        idx = n === 1 ? 0 : 1;
    }
    return forms[Math.min(idx, forms.length - 1)];
};

/** Число с неразрывным пробелом тысяч, как на макетах: 2 000 (en: 2,000). */
export const formatPoints = (n: number, lang: string): string =>
    n.toLocaleString(lang === "ru" ? "ru-RU" : "en-US").replace(/ /g, " ");
